import { USER_SETTINGS, UserSettings } from '@hb/shared'
import { useFetchData } from '../../contexts/db/FetchDataContext'

export const useMySettings = (uid: string | null) => {
  const { useDocument } = useFetchData()

  return useDocument<UserSettings>(USER_SETTINGS, uid)
}
